import { useCallback, useEffect, useState } from "react"
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap"
import { estilo_last_mile } from "../../lib/global/styles"
import PantallaCargando from "../general/pantalla_cargando"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { cerrarSesion } from "../../redux/actions/session"
import { urlapi } from "../../lib/backend/data"
import { debounce } from "@mui/material"
import CargaImagenes from "../general/carga_imagenes"
import TiposServicioSelector from "../ordenes/tipos_servicio/selector"

const PersonalizarTrackingGlobal = (props) => {
    const estructura = {
        messages: [],
        tipos_servicio: {}
    }

    const [ id, setId ] = useState("")
    const [ estructuraActual, setEstructuraActual ] = useState(estructura)
    const [ loading, setLoading ] = useState(false)
    const [ pendienteGuardar, setPendienteGuardar ] = useState(false)
    const [ tipoServicioSeleccionado, setTipoServicioSeleccionado ] = useState("")
    const session = useSelector(state => state.miusuario)
    const [ loadingGuardado, setLoadingGuardado ] = useState(false)
    const token = session.tokenSession
    const dispatch = useDispatch()
    const gris = '#e5e5e5'
    const sub_tipo = "homologaciones-mensajes"

    useEffect(() => {
        obtenerDatos(sub_tipo)
    }, [])

    const obtenerDatos = async (modulo)=>{
        setLoading(true)
        return fetch(`${urlapi}/configuracion/admin/personalizar`,{
            method:'POST',
            body: JSON.stringify({
                tipo: "tracking",
                sub_tipo: modulo,
                detalles: estructura
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res._id){
                setId(res._id)

                setEstructuraActual(res.detalles)
            }
            return setLoading(false)
        })
        .catch(error => {
            return setLoading(false)
        })
    }
    
    const guardarAutomatico = async (payload)=>{
        setLoadingGuardado(true)
        return fetch(`${urlapi}/configuracion/personalizar`,{
            method:'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            }
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
        .catch(error => {
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
    }
    
    const handleChangeExtra = (e, type, campo) => {
        const valor = e.target.value
        if(type === "modulo"){
            const i = estructuraActual.modulos.findIndex(modulo => modulo.slug === campo)
            if( i > -1 ){
                 setPendienteGuardar(true)
                 return setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.modulos[i].extra = valor
                    actualizar({ _id: id, detalles: actual })
                    return { ...actual }
                 })
            }
        }
    }

    const actualizar = useCallback(debounce((data) => guardarAutomatico(data), 1000), []);

    const addMessage = () => {
        setEstructuraActual(prev => {
            const actual = { ...prev }
            if(tipoServicioSeleccionado){
                if(!actual.tipos_servicio) actual.tipos_servicio = { }
                if(!actual.tipos_servicio[tipoServicioSeleccionado]) actual.tipos_servicio[tipoServicioSeleccionado] = { messages: [] }
                actual.tipos_servicio[tipoServicioSeleccionado].messages.push({ from: "", to: ""})
            } else {
                actual.messages.push({ from: "", to: ""})
            }
            return actual
        })
    }

    const handleChangeMessage = (e,i) => {
        const { name, value } = e.target
        return setEstructuraActual(prev => {
            let actual = {...prev}
            if(tipoServicioSeleccionado){
                actual.tipos_servicio[tipoServicioSeleccionado].messages[i][name] = name === "from" ? value.toString().toLowerCase() : value
            } else {
                actual.messages[i][name] =  name === "from" ? value.toString().toLowerCase() : value
            }
            actualizar({ _id: id, detalles: actual })
            return actual
        })
    }

    const showMessages = () => {
        const types_services = typeof estructuraActual.tipos_servicio === "object" ? estructuraActual.tipos_servicio : { }
        const messages = tipoServicioSeleccionado ? types_services[tipoServicioSeleccionado]?.messages : estructuraActual.messages
        if(!messages) return false
        return <div className="mt-3">
            {
                messages.map((msg, im) => {
                    return <Card className="p-2 mb-3" key={`message-${im}`}>
                            <Row>
                                <Col md={6}>
                                    <label className="form-control-label d-block">Texto original</label>
                                    <input placeholder="Escribe el texto actual del tracking" className="form-control" name="from" value={msg.from} onChange={(e) => handleChangeMessage(e,im)} />
                                </Col>
                                <Col md={6}>
                                    <label className="form-control-label d-block">Texto nuevo</label>
                                    <input placeholder="Escribe el texto nuevo para reemplazar el anterior" className="form-control" name="to" value={msg.to} onChange={(e) => handleChangeMessage(e,im)} />
                                </Col>
                            </Row>
                    </Card>
                })
            }
        </div>
    }
    
    if(loading) return <PantallaCargando />

    return <div>
        <Row>
            <Col><p>Actualiza la visualización por módulo y por campos </p></Col>
            <Col className="text-right text-secondary"><p>{pendienteGuardar ? "Pendiente de guardar cambios" : <b className="text-success" style={{ fontWeight: "bold" }}>¡Guardado!</b> } { loadingGuardado ? <Spinner size="sm" animation="border" variant="primary" /> : false }</p></Col>
        </Row>
        <TiposServicioSelector defaultValue={tipoServicioSeleccionado} onChangeValue={(data) => setTipoServicioSeleccionado(data?._id)} />
        <Button size="sm" variant="light" onClick={() => addMessage()}>AGREGAR MENSAJE</Button>
        {showMessages()}
    </div>
}

export default PersonalizarTrackingGlobal